import styled from 'styled-components';

const GenericModalWrapper = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-x: auto;
`;

export default GenericModalWrapper;
